import React from 'react';
import ImageGallery from 'react-image-gallery';

const Images = [
    {
        original: 'Images/seattle1.jpeg',
        thumbnail: 'Images/seattle1.jpeg',
        description: 'The Space Needle in Seattle when I visited for my buddy\'s work trip.',
        originalHeight: '450px',
    },
    {
        original: 'Images/cabo.jpeg',
        thumbnail: 'Images/cabo.jpeg',
        description: 'The Arch rocks in Cabo San Lucas, Mexico while I was on a cruise.',
        originalHeight: '450px',
    },
    {
        original: 'Images/kansascity.jpeg',
        thumbnail: 'Images/kansascity.jpeg',
        description: 'A sign in downtown Kansas City indicating the Power & Light District.',
        originalHeight: '450px',
    },
    {
        original: 'Images/kiawahisland.jpeg',
        thumbnail: 'Images/kiawahisland.jpeg',
        description: 'Myself riding a bike I rented alongside a golf course while vacationing in Kiawah Island, SC.',
        originalHeight: '450px',
    },
    {
        original: 'Images/mazatlan.jpeg',
        thumbnail: 'Images/mazatlan.jpeg',
        description: 'Riding a small boat to Deer Island in Mazatlán, Mexico to kayak as a cruise excursion.',
        originalHeight: '450px',
    },
    {
        original: 'Images/nashville.jpeg',
        thumbnail: 'Images/nashville.jpeg',
        description: 'Bridgestone Arena in Music City while I was walking down Broadway in downtown Nashville.',
        originalHeight: '450px',
    },
    {
        original: 'Images/newyork.jpeg',
        thumbnail: 'Images/newyork.jpeg',
        description: 'Entrance to the famous NYC subway I explored while I was in New Jersey to see the Jets play.',
        originalHeight: '450px',
    },
    {
        original: 'Images/norfolk.jpg',
        thumbnail: 'Images/norfolk.jpg',
        description: 'Concert that my dad\'s Army band put on in Norfolk, VA as part of a July 4th celebration.',
        originalHeight: '450px',
    },
    {
        original: 'Images/sandiego.jpeg',
        thumbnail: 'Images/sandiego.jpeg',
        description: 'Petco Park baseball stadium that I checked out while exploring San Diego.',
        originalHeight: '450px',
    },
    {
        original: 'Images/fortriley.jpeg',
        thumbnail: 'Images/fortriley.jpeg',
        description: 'A memorial tank in Fort Riley, KS that I saw while visiting my brother who\'s stationed there.',
        originalHeight: '450px',
    }
];



function GalleryPage() {
    return (
        <>
            <h2>Gallery</h2>
            <article className="gallery">
                <ImageGallery items={Images} />
            </article>
        </>
    )
}

export default GalleryPage;